const digitsOf = (value: string) => value.replace(/\D/g, '');

const shapeDigits = (digits: string): string => {
    if (digits.length === 0) {
        return '';
    }
    if (digits.length <= 3) {
        return `(${digits}`;
    }
    if (digits.length <= 6) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    }
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

/**
 * A stored phone in the one shape Portal shows, (999) 999-9999. Stored phones come in many shapes,
 * because Salesforce keeps whatever its users type. Only ten digits can be shaped without guessing,
 * so anything else is returned as stored.
 */
export const formatUsPhone = (value: string): string => {
    const digits = digitsOf(value);
    return digits.length === 10 ? shapeDigits(digits) : value;
};

/**
 * What the phone field shows while the user types: the first ten digits, shaped as far as they go.
 * Letters and punctuation are dropped. A shape is never left trailing, so backspace always removes
 * a digit.
 */
export const typeUsPhone = (value: string): string => shapeDigits(digitsOf(value).slice(0, 10));
